import { useLocation } from 'react-router'

export interface DebugQueryParams {
    forceInternal: boolean
    emailBanner: boolean
    fakeComplete: boolean
    emailVerified: boolean | null
}

const falseQueryParams: DebugQueryParams = {
    forceInternal: false,
    emailBanner: false,
    emailVerified: null,
    fakeComplete: false,
}

export const useDebugQueryParams = (): DebugQueryParams => {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)

    if (!queryParams.has('debugMode')) {
        return falseQueryParams
    }

    return {
        forceInternal: queryParams.has('forceInternal'),
        emailBanner: queryParams.has('emailBanner'),
        emailVerified: queryParams.get('emailVerified') as boolean | null,
        fakeComplete: queryParams.has('fakeComplete'),
    }
}
